export default "__VITE_ASSET__5257fa6c__"